<div *ngIf="accessDenied" class="card access_denied_card">
  <mat-icon color="warn" style="font-size: 100px; height: auto;width: auto;">warning</mat-icon>
  <h2>Access Denied</h2>
  <p>You do not have access to view this page.</p>
</div>



<div *ngIf="!accessDenied" class="container my-4">
  <div class="row">
    <div class="col-12">
      <span class="title_header_bar">Manage Relocation Retention Promotion</span>
    </div>
  </div>
  <div class="card card_content">

    <div class="row d-flex align-items-center flex-wrap grid-margin mb-3 mr-2">
      <div class="col-md-6 d-flex align-items-center">
        <app-button (refreshClicked)="clearFilter()"></app-button>

        <button class="btn excel_btn mr-3" (click)="exportToExcel()">
          <i class=" fa fa-file-excel mr-1"></i> Export
        </button>

        <button type="button" *ngIf="!this.isAdminView" class="btn btn-primary text-nowrap ml-2"
          (click)="generateLink()">
          <i class="fa fa-link"></i> Generate Link
        </button>
      </div>

      <div class="col-md-6" style="display: flex;">
        <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
          <mat-label>Search</mat-label>
          <div class="search-input-container">
            <input placeholder="Search Name / Customer Code / Application Number" id="search" matInput
              (keydown.enter)="applyFilter($event)" (keyup)="applyFilter($event)" type="text" #searchInput>
          </div>
        </mat-form-field>
        <button matSuffix mat-icon-button aria-label="Search" style="background:#7d33de !important"
          class="badge bg-light-blue image-button" (click)="applyFilter($event)">
          <mat-icon style="color: white;">search</mat-icon>
        </button>
      </div>
    </div>

    <form class="table-responsive mt-2 mb-4">
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 full-width-table">

        <!-- Agent Name-->
        <ng-container matColumnDef="agentName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Agent Name</th>
          <td mat-cell *matCellDef="let row">{{ row.agentName }}</td>
        </ng-container>

        <!-- Link -->
        <!-- <ng-container matColumnDef="link">
          <th mat-header-cell *matHeaderCellDef>Relocation Retention Link</th>
          <td mat-cell *matCellDef="let row">
            <a [href]="row.link" target="_blank">{{ row.link }}</a>
          </td>
        </ng-container> -->

        <ng-container matColumnDef="link">
          <th mat-header-cell *matHeaderCellDef>Relocation Retention Link</th>
          <td mat-cell *matCellDef="let row">
            <div class="link-box">
              <!-- Link styled like normal text -->
              <span class="link-text" [title]="row.link">{{ row.link }}</span>

              <!-- Copy icon only -->
              <mat-icon class="copy-icon" (click)="copyLink(row.link)" matTooltip="Copy referral link">
                content_copy
              </mat-icon>
            </div>
          </td>
        </ng-container>


        <!-- Customer Number -->
        <ng-container matColumnDef="customerNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Code</th>
          <td mat-cell *matCellDef="let row">{{ row.customerNumber }}</td>
        </ng-container>

        <!-- Application Number -->
        <ng-container matColumnDef="applicationNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Application Number</th>
          <td mat-cell *matCellDef="let row">{{ row.applicationNumber }}</td>
        </ng-container>

        <!-- Promotion Status -->
        <ng-container matColumnDef="applicationStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Application Status</th>
          <td mat-cell *matCellDef="let row">{{ row.applicationStatusTypeName }}</td>
        </ng-container>

        <!-- Promotion Status -->
        <ng-container matColumnDef="promotionStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Promotion Status</th>
          <td mat-cell *matCellDef="let row">{{ row.promotionStatusTypeName }}</td>
        </ng-container>

        <!-- Promotion Status -->
        <ng-container matColumnDef="creditButton">
          <th mat-header-cell *matHeaderCellDef>Pay Credit</th>
          <td mat-cell *matCellDef="let row">
            <!-- Show plain text when promotionStatus == 6 -->
            <span *ngIf="row.promotionStatus == 6" class="paid-text">PAID</span>

            <!-- Otherwise show the button -->
            <button *ngIf="row.promotionStatus != 6" class="credit-btn" (click)="creditAmount(row)"
              [disabled]="row.applicationStatus !== 22">
              PAY CREDIT
            </button>
          </td>
        </ng-container>


        <!-- Header & Rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- No Data -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
            No data found
          </td>
        </tr>
      </table>
    </form>

    <!-- Paginator -->
    <div class="table_pagenation">
      <mat-paginator #paginator [length]="dataSource?.filteredData.length || 0" [pageIndex]="0" [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 100]">
      </mat-paginator>
    </div>

  </div>
</div>